export default {
    SET_PROPERTIES(state, properties) {
        state.data = properties;
    },
    CLEAR_PROPERTIES(state) {
        state.data = [];
    }
}